import { AnyAction } from "redux";
import { actionCreator } from "@ps/utils";
import ActionTypes from "./actionTypes";

export const setRedirection = (): AnyAction =>
  actionCreator(ActionTypes.SET_ALERT_MODAL);

export const clearRedirection = (): AnyAction =>
  actionCreator(ActionTypes.CLEAR_ALERT_MODAL);
